import { getAPI } from "./axios-base";

export default class RestResourceGalery {
  getGalery(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/galery", {
      params: params
    });
  }
  postGalery(body: any) {
    const formdata = new FormData();
    formdata.append("name", body.name);
    if (body.file) {
      formdata.append(`files[0]`, body.file);
    }
    return getAPI.post("api/rest/v1/galery/upload-pictures", formdata, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
}
